export class HoncalyzerApiError extends Error {
  constructor(
    public statusCode: number,
    message: string,
  ) {
    super(message);
    this.name = "HoncalyzerApiError";
  }
}

export async function baseFetch<T>(
  url: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(url, {
    credentials: "include",
    ...options,
  });

  if (!response.ok) {
    throw new HoncalyzerApiError(
      response.status,
      `HTTP ${response.status}: ${response.statusText}`,
    );
  }

  return response.json();
}
